import { Injectable } from '@angular/core';
import { getApps, getApp } from 'firebase/app';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FirebaseTestService {
    
    constructor() {
        // Delay the test to ensure Firebase is initialized
        setTimeout(() => {
            this.testFirebaseConfig();
        }, 1000);
    }

    private async testFirebaseConfig() {        
        try {
            // Check existing Firebase apps
            const existingApps = getApps();            
            // Test config loading
            const config = this.loadFirebaseConfigSync();
            if (config) {
                console.log('✅ Firebase config loaded successfully:', {
                    projectId: config.projectId,
                    authDomain: config.authDomain,
                    apiKey: config.apiKey ? '***' + config.apiKey.slice(-4) : 'not set'
                });
            } else {
                console.warn('⚠️ No Firebase config loaded');
            }

            // Test Firebase app availability
            if (existingApps.length > 0) {
                const firebaseApp = getApp();
                console.log('✅ Firebase app instance available:', {
                    name: firebaseApp.name,
                    options: firebaseApp.options
                });
            } else {
                console.warn('⚠️ No Firebase app instances found');
            }

            // Final check
            const finalApps = getApps();

        } catch (error) {
            console.error('❌ Error testing Firebase config:', error);
        }
    }

    private loadFirebaseConfigSync(): any {
        const configFile = environment.firebaseConfigFile;
        try {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', configFile, false);
            xhr.send();
            
            if (xhr.status === 200) {
                return JSON.parse(xhr.responseText);
            }
        } catch (error) {
            console.warn('⚠️ Failed to load Firebase config in test service:', error);
        }
        return null;
    }
} 